import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_BOOK_APPOINTMENT_USER } from '../../queries/get-user.js';

const useUser = ()=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_USER);
    const userQuery = React.useCallback((token)=>query({
            context: {
                forwardHeaders: {
                    Authorization: `Bearer ${token}`
                }
            }
        })
    , [
        query
    ]);
    var ref;
    const data = React.useMemo(()=>{
        var ref1;
        return (ref = (ref1 = queryState.data) === null || ref1 === void 0 ? void 0 : ref1.me) !== null && ref !== void 0 ? ref : undefined;
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            userQuery,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        userQuery,
        queryState,
        data
    ]);
};
var useUser$1 = useUser;

export { useUser$1 as default, useUser };
//# sourceMappingURL=use-user.js.map
